import { collection, getDocs, setDoc, doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import translationIT from '../i18n/locales/it.json';

// Cache per memorizzare i dati e ridurre le chiamate a Firestore
const cache = {
    pastaTypes: null,
    sauces: null,
    drinks: null,
    translations: null
};

export const fetchPastaTypes = async () => {
    if (cache.pastaTypes) return cache.pastaTypes;

    try {
        const querySnapshot = await getDocs(collection(db, 'pastaTypes'));
        const pastaTypes = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
        }));
        cache.pastaTypes = pastaTypes;
        return pastaTypes;
    } catch (error) {
        console.error('Error fetching pasta types:', error);
        return [];
    }
};

export const fetchSauces = async () => {
    if (cache.sauces) return cache.sauces;

    try {
        const querySnapshot = await getDocs(collection(db, 'sauces'));
        const sauces = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
        }));
        cache.sauces = sauces;
        return sauces;
    } catch (error) {
        console.error('Error fetching sauces:', error);
        return [];
    }
};

export const fetchDrinks = async () => {
    if (cache.drinks) return cache.drinks;

    try {
        const querySnapshot = await getDocs(collection(db, 'drinks'));
        const drinks = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
        }));
        cache.drinks = drinks;
        return drinks;
    } catch (error) {
        console.error('Error fetching drinks:', error);
        return [];
    }
};







// Funzioni per gestire le traduzioni
export const fetchTranslations = async (language = 'it') => {
    if (cache.translations) return cache.translations;

    try {
        const docRef = doc(db, 'translations', language);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            const flattenedTranslations = docSnap.data();
            // Converto l'oggetto appiattito in un oggetto annidato
            const translations = unflattenObject(flattenedTranslations);
            cache.translations = translations;
            return translations;
        } else {
            console.log('No translations found, using default');
            return translationIT;
        }
    } catch (error) {
        console.error('Error fetching translations:', error);
        return translationIT;
    }
};

// Funzione per convertire un oggetto appiattito in un oggetto annidato
const unflattenObject = (obj) => {
    const result = {};

    for (const key in obj) {
        const keys = key.split('.');
        let current = result;

        for (let i = 0; i < keys.length; i++) {
            const k = keys[i];
            if (i === keys.length - 1) {
                // Ultimo elemento, assegna il valore
                current[k] = obj[key];
            } else {
                // Crea l'oggetto annidato se non esiste
                current[k] = current[k] || {};
                current = current[k];
            }
        }
    }

    return result;
};

export const loadTranslationsToFirestore = async () => {
    try {
        // Carica le traduzioni italiane
        // Firestore ha limiti sulla profondità dei documenti, quindi appiattisco l'oggetto
        const flattenedTranslations = flattenObject(translationIT);
        await setDoc(doc(db, 'translations', 'it'), flattenedTranslations);

        console.log('Translations loaded successfully to Firestore');
        // Invalida la cache dopo il caricamento
        cache.translations = null;
        return true;
    } catch (error) {
        console.error('Error loading translations to Firestore:', error);
        return false;
    }
};

// Funzione per appiattire un oggetto annidato
const flattenObject = (obj, prefix = '') => {
    return Object.keys(obj).reduce((acc, k) => {
        const pre = prefix.length ? `${prefix}.` : '';
        if (typeof obj[k] === 'object' && obj[k] !== null && !Array.isArray(obj[k])) {
            Object.assign(acc, flattenObject(obj[k], `${pre}${k}`));
        } else {
            acc[`${pre}${k}`] = obj[k];
        }
        return acc;
    }, {});
};

// Funzione principale che carica tutti i dati
export const loadAllDataToFirestore = async () => {
    try {
        await Promise.all([
            loadTranslationsToFirestore()
        ]);

        console.log('All data loaded successfully to Firestore');
        return true;
    } catch (error) {
        console.error('Error loading all data to Firestore:', error);
        return false;
    }
};
